import { globalConst as native } from 'lib/const'

export const getRequest = 'get'
export const postRequest = 'post'
export const jsonpRequest = 'jsonp'

class ApiConfig {
  constructor (name, url, config, method = postRequest, opts = {}, apiParams = {}) {
    this.name = name
    this.url = url
    this.method = method
    this.opts = opts
    this.apiParams = apiParams
    if (config && typeof config === 'object') {
      this.config = config
      this.method = method
    } else if (config && typeof config === 'string') {
      this.apiParams = opts
      this.method = config
      this.opts = method
    } else {
      this.config = {}
    }

  }
}

function _apiConfig (url, config, methods, opts = {}) {
  return function (name, apiParams) {
    return new ApiConfig(name, url, config, methods, opts, apiParams)
  }
}

const readBlock = _apiConfig('/readblock', {global: false}, jsonpRequest)
const loadService = _apiConfig('', {global: false, isNeedAuthor: false}, postRequest)
let apiConfig = [
  new ApiConfig(native.delDevice, '/user/profile/delDevice'),
  new ApiConfig(native.loadDeviceList, '/user/profile/deviceList', {global: false}),
  new ApiConfig(native.updateDevice, '/user/profile/updateDevice', {global: false}),
  new ApiConfig(native.changeDevice, '/user/profile/changeDevice', {global: false}),
  new ApiConfig(native.doBindDevice, '/user/profile/bindDevice', {global: false}),
  new ApiConfig(native.resList, '/downloader/res/list', {global: false}),
  new ApiConfig(native.resListAll, '/downloader/res/listAll', {global: false}),
  new ApiConfig(native.resTypeList, '/downloader/res/typeList', {global: false}),
  new ApiConfig(native.resSearch, '/downloader/res/search', {global: false}),
  new ApiConfig(native.resDetail, '/downloader/res/resDetail'),
  new ApiConfig(native.installPack, '', {isNeedAuthor: false}),
  new ApiConfig(native.loadServerUrl, '', {global: false, isNeedAuthor: false}),
  new ApiConfig(native.doLoadJsConfig, '/wechat/downLoadWxconfig', {global: false}),
  new ApiConfig(native.downLoad, '/download', {isNeedAuthor: false, global: true}, jsonpRequest),
  new ApiConfig(native.listFile, '/listfile', {global: false, isNeedAuthor: false}, jsonpRequest),
  new ApiConfig(native.readBlock, '/readblock', {global: false, isNeedAuthor: false}, jsonpRequest),
  new ApiConfig(native.rename, '/rename', {isNeedAuthor: false}, jsonpRequest),
  new ApiConfig(native.writeBlock, '/writeblock', {isNeedAuthor: false}, jsonpRequest),
  new ApiConfig(native.queryDownLoadProcess, '/processbar', {global: false, isNeedinstallPackAuthor: false}, jsonpRequest),
  new ApiConfig(native.delFile, '/delFile', {isNeedAuthor: false, global: false}, jsonpRequest),
  new ApiConfig(native.getDevice, '/getdeviceid', {global: false, isNeedAuthor: false}, jsonpRequest),
  new ApiConfig(native.getVersion, '/getVersion', {global: false, isNeedAuthor: false}, jsonpRequest),
  new ApiConfig(native.softwareUpdate, '/softwareUpdate', {global: false, isNeedAuthor: false}, jsonpRequest),
  new ApiConfig(native.softwareUpdateProcess, '/UpdateQuery', {global: false, isNeedAuthor: false}, jsonpRequest),
  new ApiConfig(native.reboot, '/reboot', {global: false, isNeedAuthor: false}, jsonpRequest),
  readBlock(native.readEncryption, {
    filename: 'SYS/INI/product.ini',
    org_offset: 0,
    len: 11,
    flag: 'end'
  }),
  readBlock(native.readSerial, {}),
  readBlock(native.readBeforeThreeBit, {
    org_offset: 0,
    len: 3,
    flag: 'end'
  }),
  loadService(native.loadNowVersion, {
    function: 'getversion'
  })
]
export default apiConfig
